module.exports = __webpack_public_path__ + "img/xiaoman2.7633642c.png";